import "./Header.css";

import { connect } from "react-redux";
import {
  ArrowDownwardIcon,
  ArrowUpwardIcon,
  VisibilityIcon,
  VisibilityOffIcon,
  SearchIcon,
} from "../../utils/icons";

import { getStatsColumnMapping } from "../../utils/columnsJsonInformation";
import {
  findSportByLeague,
  player_responsibility_mapping,
} from "../../utils/utils";
import {
  setSortType,
  setPositionFilter,
  setPlRes,
  setPlayerSearchedName,
  setPlayerLFDCount,
  setPlayerCounts,
  setDisplayPlayers,
} from "../../redux";

import { setPlayerStat } from "../../redux/PlayerStatsInformation/PlayerStatInformationAction";

// import React from "react";
import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Divider from "@material-ui/core/Divider";
import {
  setIsResetClicked,
  setPlayerStatus,
  setTeamFilter,
  updateDisplayPlayers,
} from "../../redux/GameInformation/GameInformationAction";
// Drawer styles

import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import { API_CONSTANTS } from "../../utils/constantInformation";

import LoadingOverlay from "react-loading-overlay";
import { getID, remoteConfig } from "../../firebase";
import {
  deleteDocument,
  getExcludedPlayerForSlate,
  getLockedPlayerForSlate,
} from "../../firestoreQueries";
import { getSportPlayerPositions } from "../../utils/sportsConfig";

const Header = React.memo(
  (props) => {
    // Drawer code
    const theme = createTheme({
      palette: {
        primary: {
          main: "#2C7BFF",
          dark: "#343A40",
          light: "#F8F9FA",
        },
        secondary: { main: "#6C757D" },
        background: {
          default: "#343A40",
          paper: "#343A40",
        },
      },
    });

    const useStyles = makeStyles({
      list: {
        width: 250,
      },
      fullList: {
        width: "auto",
      },
      color: "bg-dark",
    });
    // Drawer styles end
    const classes = useStyles();

    const [state, setState] = React.useState({
      top: false,
      left: false,
      bottom: false,
      right: false,
    });

    const toggleDrawer = (anchor, open) => (event) => {
      if (
        event.type === "keydown" &&
        (event.key === "Tab" || event.key === "Shift")
      ) {
        return;
      }

      setState({ ...state, [anchor]: open });
    };

    // Drawer code end
    const [sortTypeName, setSortTypeName] = React.useState(null);

    const [selectPositionFilter, setPositionFilter] = React.useState(
      props.player_information.gameInformationReducer.player_position_filter
    );

    const [teamFilter, setTeamFilter] = React.useState(
      props.player_information.gameInformationReducer.filtered_team
    );

    const [PlRes, setPlRes] = React.useState(
      props.player_information.gameInformationReducer.pl_res
    );

    const [playerStatus, setPlayerStatus] = React.useState(
      props.player_information.gameInformationReducer.player_status
    );

    // Timer States

    const [timeLeftDays, setTimeLeftDays] = React.useState(null);
    const [timeLeftHours, setTimeLeftHours] = React.useState(null);
    const [timeLeftMinutes, setTimeLeftMinutes] = React.useState(null);
    const [timeLeftSeconds, setTimeLeftSeconds] = React.useState(null);
    const [isActive, setIsActive] = React.useState(false);
    const [lfdCountData, setLFDCountData] = React.useState(
      props.player_information.gameInformationReducer.slate_lfd_count
    );
    let interval = React.useRef();
    const startTimer = (date) => {
      console.log(
        "[Header timer] Count Down Datetime:: ",
        props.player_information.gameInformationReducer.match_datetime
      );
      interval.current = setInterval(() => {
        const countDownDate = new Date(date).getTime();
        const now = new Date().getTime();
        const difference = countDownDate - now;
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        let hours = Math.floor(
          (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor(
          (difference % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);
        let formattedDays = days.toLocaleString("en-US", {
          minimumIntegerDigits: 2,
          useGrouping: false,
        });
        let formattedHours = hours.toLocaleString("en-US", {
          minimumIntegerDigits: 2,
          useGrouping: false,
        });
        let formattedMinutes = minutes.toLocaleString("en-US", {
          minimumIntegerDigits: 2,
          useGrouping: false,
        });
        let formattedSeconds = seconds.toLocaleString("en-US", {
          minimumIntegerDigits: 2,
          useGrouping: false,
        });

        if (difference < 0) {
          clearInterval(interval.current);
          setTimeLeftDays(null);
          setTimeLeftHours("00");
          setTimeLeftMinutes("00");
          setTimeLeftSeconds("00");
        } else {
          if (days == 0) {
            setTimeLeftDays(null);
          } else {
            setTimeLeftDays(formattedDays);
          }
          setTimeLeftHours(formattedHours);
          setTimeLeftMinutes(formattedMinutes);
          setTimeLeftSeconds(formattedSeconds);
        }
      }, 1000);
      console.log("Interval", interval.current);
    };
    // props.league may be null
    React.useEffect(() => {
      console.log("starting timer");
      clearInterval(interval.current);
      console.log(
        "LFD COUNTS UE ST: ",
        props.player_information.gameInformationReducer.slate_lfd_count
      );
      // startTimer(props.player_information.gameInformationReducer.match_datetime);
      startTimer(
        props.player_information.gameInformationReducer.match_datetime
      );
      console.log("log1", interval.current);
      if (props.league != null) {
        const stats = getStatsColumnMapping(
          props.league,
          props.remoteConfig
        ).filter((el) => {
          return (
            el.actual_name ==
            props.player_information.gameInformationReducer.player_sort_type
          );
        });
        setSortTypeName(stats[0].display_name);
        console.log(props.player_information.gameInformationReducer);

        console.log(
          "LFD COUNTS UE END: ",
          props.player_information.gameInformationReducer.slate_lfd_count
        );
      }
    }, [
      props.player_information.gameInformationReducer.match_datetime,
      props.player_information.gameInformationReducer.game_teams,
      props.player_information.gameInformationReducer.slate_lfd_count,
      props.player_information.gameInformationReducer.player_counts,
    ]);

    function setSortType(value, reducer_name) {
      const flag =
        props.player_information.playerStatInformationReducer[reducer_name] ==
        true;
      console.log("Player Sort Type: ", value, reducer_name, flag);
      if (
        props.player_information.playerStatInformationReducer[reducer_name] ==
        true &&
        props.league != null
      ) {
        const stats = getStatsColumnMapping(
          props.league,
          props.remoteConfig
        ).filter((el) => {
          return el.actual_name == value;
        });

        let player_sort_type_and_order = { sort_name: value };

        if (
          props.player_information.gameInformationReducer.player_sort_type ==
          value
        ) {
          if (
            props.player_information.gameInformationReducer.player_sort_order ==
            "ASC"
          ) {
            player_sort_type_and_order.sort_order = "DESC";
          } else {
            player_sort_type_and_order.sort_order = "ASC";
          }
        } else {
          player_sort_type_and_order.sort_order = "DESC";
        }

        setSortTypeName(stats[0].display_name);
        props.player_sort_value(player_sort_type_and_order);
      }
    }
    const PLAYER_STATUSES = [
      "Announced",
      "Substitute",
      "Played last match",
      "Played last match(sub_in)",
      "Played last match(sub_out)",
    ];
    function get_player_for_position_team_and_store_name(
      position,
      team,
      status
    ) {
      let toFilterPlayerString =
        props.player_information.gameInformationReducer.player_searched_name;

      const filtered_players =
        props.player_information.gameInformationReducer.display_players.filter(
          (val) => {
            if (val.deleted) return;
            if (
              toFilterPlayerString !== "" &&
              !val.OperatorPlayerName.toLowerCase().includes(
                toFilterPlayerString
              )
            )
              return;
            if (
              status !== API_CONSTANTS.NULL_CONSTANT &&
              !PLAYER_STATUSES.includes(val.OperatorMatchInfo)
            )
              return;
            if (position !== "ALL" && val.Position !== position) return;
            if (team !== "Both" && val.Team !== team) return;
            return val;
          }
        );

      return filtered_players.length;
    }

    function changePlayerStatusFilter(status) {
      const currentPlayerStatusInRedux =
        props.player_information.gameInformationReducer.player_status;
      console.log("changePlayerStatus", currentPlayerStatusInRedux, status);

      setPlayerStatus(status);
      props.update_player_status(status);
      let new_player_count = get_player_for_position_team_and_store_name(
        selectPositionFilter,
        teamFilter,
        status
      );
      console.log("change player status filter player count", new_player_count);
      console.log(
        " props updating player count on change player status filter"
      );
      // alert("player status filter " + new_player_count + " updated");
      props.update_player_counts(new_player_count);
    }

    function changePositionFilter(position) {
      setPositionFilter(position);
      props.player_position_filter(position);
      let new_player_count = get_player_for_position_team_and_store_name(
        position,
        teamFilter,
        playerStatus
      );
      console.log("change position filter player count" + new_player_count);
      console.log(" props updating player count on change position filter");
      // alert("player position filter " + new_player_count + " updated");
      props.update_player_counts(new_player_count);
    }

    function filterTeam(team) {
      setTeamFilter(team);
      props.update_filtered_team(team);
      console.log(
        "In Filter Team --> The position state",
        selectPositionFilter
      );
      let new_player_count = get_player_for_position_team_and_store_name(
        selectPositionFilter,
        team,
        playerStatus
      );
      console.log(" props updating player count on filter team");
      props.update_player_counts(new_player_count);
      // toggleDrawer("bottom", false);
    }

    function changePlRes(res) {
      setPlRes(res);
      props.pl_res(res);
    }
    function updateVisibility(e, column_names) {
      e.preventDefault();
      console.log("column_names", column_names);
      let statName = column_names.reducer_name;

      let currentStatValue =
        props.player_information.playerStatInformationReducer[
        column_names.reducer_name
        ];
      let newStatValue = !currentStatValue;
      console.log(
        "stat",
        statName,
        "currVal",
        currentStatValue,
        "newVal",
        newStatValue
      );
      props.updateStatVisibility(statName, newStatValue);
    }

    const get_filtered_player_count = (
      display_players,
      teamFilter,
      positionFilter,
      statusFilter,
      searchQuery
    ) => {
      const filteredPlayers = display_players.filter((player) => {
        if (player.deleted) {
          return false;
        }

        if (teamFilter !== "All" && player.Team !== teamFilter) {
          return false;
        }

        if (positionFilter !== "ALL" && player.Position !== positionFilter) {
          return false;
        }

        if (statusFilter) {
          if (statusFilter === "Played last match") {
            if (
              player.Status !== "Played last match" &&
              player.Status !== "Played last match (sub_in)" &&
              player.Status !== "Played last match (sub_out)"
            ) {
              return false;
            }
          } else if (statusFilter === "Unannounced") {
            if (
              player.Status &&
              player.Status !== "Played last match" &&
              player.Status !== "Played last match (sub_in)" &&
              player.Status !== "Played last match (sub_out)" &&
              player.Status !== "Announced"
            ) {
              return false;
            }
          } else if (player.Status !== statusFilter) {
            return false;
          }
        }

        if (
          searchQuery !== "" &&
          !player.OperatorPlayerName.toLowerCase().includes(
            searchQuery.toLowerCase()
          )
        ) {
          return false;
        }

        return true;
      });

      return filteredPlayers.length;
    };

    function handleSearchChange(e, direct = true) {
      e.preventDefault();
      console.log("Position Filter", selectPositionFilter);
      const team =
        props.player_information.gameInformationReducer.filtered_team;
      let toFilter;
      if (direct == true) {
        console.log("Search", e.target.value.toLowerCase());
        toFilter = e.target.value.toLowerCase();
      } else {
        console.log("Indirect Search Called");
        toFilter = e.toLowerCase();
        console.log(toFilter);
      }
      const filtered_player_count = get_filtered_player_count(
        props.player_information.gameInformationReducer.display_players,
        teamFilter,
        selectPositionFilter,
        playerStatus,
        toFilter
      );

      // TODO: Also filter on Player Position as well
      console.log("Filtered Player Count", filtered_player_count);
      console.log(" props updating player count on handle player search");
      // alert("Search Filtered Player Count " + filtered_player_count);

      props.update_player_counts(filtered_player_count);
      // setPlayerCount(filtered_player_count);
      console.log(
        "state value",
        props.player_information.gameInformationReducer.player_counts
      );
      if (direct == true) {
        props.updatePlayerSearchTerm(e.target.value);
      } else {
        props.updatePlayerSearchTerm(e);
      }
    }
    const openLineupModal = () => {
      // document.getElementById("backdrop").style.display = "block";
      document.getElementById("staticBackdropLineUp").style.display = "block";
      document.getElementById("staticBackdropLineUp").classList.add("show");
    };
    const closeLineupModal = () => {
      // document.getElementById("backdrop").style.display = "block";
      document.getElementById("staticBackdropLineUp").style.display = "none";
      document.getElementById("staticBackdropLineUp").classList.remove("show");
    };
    // console.log("Header.js");
    const resetPlayersInDisplayList = (locked, excluded, playersToDelete) => {
      // props.
      // Reset the flags in display_players
      const currentDisplayPlayerList =
        props.player_information.gameInformationReducer.display_players;
      console.log("CDPL:: ", currentDisplayPlayerList);
      currentDisplayPlayerList.forEach((currentPlayer) => {
        for (let i = 0; i < playersToDelete.length; i++) {
          const playerToDelete = playersToDelete[i];
          console.log(
            "Player ID comparison: ",
            playerToDelete.player.dream_11_id,
            currentPlayer.OperatorPlayerID
          );
          if (
            playerToDelete.player.dream_11_id ===
            currentPlayer.OperatorPlayerID.toString()
          ) {
            let data = {
              operator_player_id: currentPlayer.OperatorPlayerID,
              locked: locked,
              favourite: false,
              excluded: excluded,
            };

            props.update_player_lfd_flag(data);
            console.log("Reset Display Player Completed", currentPlayer);
          }
        }
      });

      let data;

      if (excluded === true) {
        data = {
          ...props.state_slate_lfd_count,
          excluded: 0,
        };
      }
      if (locked === true) {
        data = {
          ...props.state_slate_lfd_count,
          locked: 0,
        };
      }
      props.update_lfd_count(data);
      console.log("Reset Done");
      // Update Reset Flag
      props.update_is_reset_clicked(true);
      // adding explicit delay
      setTimeout(() => {
        props.update_display_players(currentDisplayPlayerList);
        props.update_is_reset_clicked(false);
        setIsActive(false);
      }, 500);
    };
    const resetSlateLFD = async (locked, favourite, excluded) => {
      // Show pre-loader
      setIsActive(true);
      const slate_id = props.player_information.gameInformationReducer.slate_id;
      const userId = getID();
      let currentDisplayPlayerList;
      console.log("User Id in Reset", userId);

      if (locked === true) {
        const lockedPlayers = getLockedPlayerForSlate(userId, slate_id);
        lockedPlayers
          .then((querySnapshot) => {
            querySnapshot.forEach((document) => deleteDocument(document));
          })
          .catch((error) => {
            console.log("Firestore LFD", error.message);
          });
        resetPlayersInDisplayList(locked, excluded, lockedPlayers);
      } else if (excluded === true) {
        const excludedPlayers = getExcludedPlayerForSlate(userId, slate_id);
        excludedPlayers
          .then((querySnapshot) => {
            querySnapshot.forEach((document) => deleteDocument(document));
          })
          .catch((error) => {
            console.log("Firestore LFD", error.message);
          });
        resetPlayersInDisplayList(locked, excluded, excludedPlayers);
      }
      // alert("Reset Successfull");
    };

    // hide pre-loader
    return (
      <>
        <header className="sticky-top">
          <LoadingOverlay
            active={isActive}
            spinner
            text="Loading your content..."
          >
            <nav
              className="navbar navbar-expand-md sticky-top bg-dark border-left-0 border-right-0 border-top border-bottom navbar-light"
              style={
                props.view_selected == "Players" ? { display: "none" } : {}
              }
            >
              <div className="d-flex justify-content-between">
                <div className="d-flex flex-nowrap">
                  <a
                    className="nav-link disabled text-white text-nowrap text-white"
                    href="#"
                  >
                    <b>
                      {
                        props.player_information.gameInformationReducer
                          .player_counts
                      }{" "}
                      {props.player_information.gameInformationReducer
                        .player_counts == 1
                        ? "player"
                        : "players"}
                    </b>
                  </a>
                  <a
                    className={`nav-link font-weight-bolder text-nowrap text-danger`}
                    href="#"
                    style={{
                      cursor: "text",
                      pointerEvents: "none",
                    }}
                  >
                    {timeLeftDays ? `${timeLeftDays}d : ` : <></>}
                    {timeLeftHours}
                    {"h : "}
                    {timeLeftMinutes}
                    {"m : "}
                    {timeLeftSeconds}
                    {"s"}
                  </a>
                </div>
              </div>
              <div className="d-flex w-100 m-1 p-1 bg-dark border border-secondary rounded">
                <input
                  className=" w-100 bg-dark border-0 shadow-none text-white align-self-center"
                  type="text"
                  name=""
                  id=""
                  placeholder="Search"
                  onChange={(e) => handleSearchChange(e, true)}
                  value={
                    props.player_information.gameInformationReducer
                      .player_searched_name
                  }
                ></input>
                <SearchIcon className="text-white align-self-center" />
              </div>

              <div
                className="navbar-collapse collapse pt-2 pt-md-0"
                id="navbar2"
              >
                <ul className="navbar-nav navbar-right ml-auto">
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle text-white"
                      href="#"
                      id="navbarDropdown2"
                      role="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <b>
                        {
                          props.player_information.gameInformationReducer
                            .player_position_filter
                        }
                      </b>
                    </a>

                    <div
                      className=" dropdown-menu bg-dark dropdown-menu-lg-right dropdown-menu-md-right filter-by"
                      aria-labelledby="navbarDropdown2"
                    >
                      {props.league !== undefined &&
                        props.league !== null &&
                        getSportPlayerPositions(
                          findSportByLeague(
                            props.league,
                            props.remoteConfig,
                            "header position filter"
                          )
                        ).map((position, index) => (
                          <span
                            className="dropdown-item"
                            onClick={() =>
                              changePositionFilter(position.display_name)
                            }
                            key={index}
                            role="button"
                          >
                            <div className="text-white">
                              {position.display_name}
                            </div>
                            <div className="text-muted">
                              <small>{position.description}</small>
                            </div>
                          </span>
                        ))}
                    </div>
                  </li>
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle text-white"
                      href="#"
                      id="navbarDropdown"
                      role="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <b>{sortTypeName}</b>
                      <span>
                        <ArrowUpwardIcon
                          style={
                            props.player_information.gameInformationReducer
                              .player_sort_order == "ASC"
                              ? {}
                              : { display: "none" }
                          }
                        ></ArrowUpwardIcon>
                        <ArrowDownwardIcon
                          style={
                            props.player_information.gameInformationReducer
                              .player_sort_order == "DESC"
                              ? {}
                              : { display: "none" }
                          }
                        ></ArrowDownwardIcon>
                      </span>
                    </a>
                    <div
                      className="dropdown-menu bg-dark dropdown-menu-lg-right dropdown-menu-md-right sort-by"
                      aria-labelledby="navbarDropdown"
                    >
                      {props.league &&
                        getStatsColumnMapping(
                          props.league,
                          props.remoteConfig
                        ).map((column_names, index) => (
                          // TODO: whenever we are ready with the GPP and H2H, remove the conditional class rendenring. (hide-stat)
                          <div
                            className={`${column_names.reducer_name != "ps_proj_fp"
                                ? column_names.show == true
                                  ? ""
                                  : "hide-stat"
                                : ""
                              } p-2 border-bottom mt-1 border-secondary d-flex justify-content-between dropdown-custom`}
                            key={index}
                          >
                            <div className="d-flex justify-content-between">
                              <div
                                className={`${props.player_information
                                    .playerStatInformationReducer[
                                    column_names.reducer_name
                                  ]
                                    ? ""
                                    : "disabled"
                                  }
                      `}
                                onClick={() =>
                                  setSortType(
                                    column_names.actual_name,
                                    column_names.reducer_name
                                  )
                                }
                                style={{ cursor: "pointer" }}
                              >
                                <p className="m-0 p-0 full-name ">
                                  <b>{column_names.full_name}</b>
                                </p>
                                <p className="m-0 p-0 text-white">
                                  <small>{column_names.display_name}</small>
                                </p>
                                {column_names.description ? (
                                  <p className="m-0 p-0 ">
                                    <small className="text-white text-muted">
                                      {column_names.description}
                                    </small>
                                  </p>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                            {column_names.reducer_name != "ps_proj_fp" ? (
                              <div className="ml-auto align-items-center align-self-center">
                                {props.player_information
                                  .playerStatInformationReducer[
                                  column_names.reducer_name
                                ] ? (
                                  <VisibilityIcon
                                    className="text-white"
                                    style={{ cursor: "pointer" }}
                                    onClick={(e) =>
                                      updateVisibility(e, column_names)
                                    }
                                  />
                                ) : (
                                  <VisibilityOffIcon
                                    className="text-white"
                                    style={{ cursor: "pointer" }}
                                    onClick={(e) =>
                                      updateVisibility(e, column_names)
                                    }
                                  />
                                )}
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>
                        ))}
                    </div>
                  </li>
                  <ThemeProvider theme={theme}>
                    {["bottom"].map((anchor) => (
                      <React.Fragment key={anchor}>
                        <li
                          className="nav-link dropdown-toggle text-white font-weight-bold"
                          onClick={toggleDrawer(anchor, true)}
                        >
                          Filter
                        </li>
                        <Drawer
                          anchor={anchor}
                          open={state[anchor]}
                          onClose={toggleDrawer(anchor, false)}
                        >
                          <div
                            className={clsx(classes.list, {
                              [classes.fullList]:
                                anchor === "top" || anchor === "bottom",
                              [classes.color]:
                                anchor === "top" || anchor === "bottom",
                            })}
                            role="presentation"
                            onClick={toggleDrawer(anchor, false)}
                            onKeyDown={toggleDrawer(anchor, false)}
                          >
                            <span
                              className="dropdown-item disabled text-muted font-weight-bold"
                              style={{ cursor: "none" }}
                            >
                              Teams
                            </span>
                            <span
                              className={`dropdown-item ${props.player_information.gameInformationReducer
                                  .filtered_team === "Both"
                                  ? "disabled"
                                  : ""
                                }`}
                              onClick={() => filterTeam("Both")}
                            >
                              <div className="text-white">Both</div>
                              <div className="text-muted">
                                <small>All players of both teams</small>
                              </div>
                            </span>
                            {props.player_information.gameInformationReducer.game_teams.map(
                              (gameTeam, index) => (
                                <span
                                  className={`dropdown-item ${props.player_information
                                      .gameInformationReducer.filtered_team ===
                                      gameTeam.abbr
                                      ? "disabled"
                                      : ""
                                    }`}
                                  role="button"
                                  onClick={() => filterTeam(gameTeam.abbr)}
                                  key={index}
                                >
                                  <div className="text-white">
                                    {gameTeam.abbr}
                                  </div>
                                  <div className="text-muted">
                                    <small>{gameTeam.full_name}</small>
                                  </div>
                                </span>
                              )
                            )}
                            <Divider />
                            <span
                              className="dropdown-item disabled text-muted font-weight-bold"
                              style={{ cursor: "none" }}
                            >
                              Player Status
                            </span>
                            <span
                              className="dropdown-item "
                              onClick={() =>
                                changePlayerStatusFilter(
                                  API_CONSTANTS.NULL_CONSTANT
                                )
                              }
                            >
                              <div className="text-white">All</div>
                              <div className="text-muted">
                                <small>Squad of both teams</small>
                              </div>
                            </span>
                            <span
                              className="dropdown-item "
                              role="button"
                              onClick={() => changePlayerStatusFilter("Active")}
                            >
                              <div className="text-white">Active Players</div>
                              <div className="text-muted">
                                <small>
                                  Playing 11 / Played last game{" "}
                                  <small>
                                    <i>Substitute Included</i>
                                  </small>
                                </small>
                              </div>
                            </span>
                            <Divider />
                            {props.state_slate_locked_count > 0 ||
                              props.state_slate_favourite_count > 0 ||
                              props.state_slate_excluded_count > 0 ? (
                              <span
                                className="dropdown-item disabled text-muted font-weight-bold"
                                style={{ cursor: "none" }}
                              >
                                Edit Exposure
                              </span>
                            ) : null}
                            {props.player_information.gameInformationReducer
                              .slate_lfd_count.locked > 0 ? (
                              <>
                                <span
                                  className="dropdown-item "
                                  onClick={async () =>
                                    await resetSlateLFD(true, false, false)
                                  }
                                >
                                  <div className="text-danger">
                                    Reset Locked Players (
                                    {
                                      props.player_information
                                        .gameInformationReducer.slate_lfd_count
                                        .locked
                                    }
                                    )
                                  </div>
                                </span>
                                <Divider />
                              </>
                            ) : null}
                            {props.player_information.gameInformationReducer
                              .slate_lfd_count.favourite > 0 ? (
                              <>
                                <span
                                  className="dropdown-item "
                                  onClick={async () =>
                                    await resetSlateLFD(false, true, false)
                                  }
                                // key={index}
                                >
                                  <div className="text-danger">
                                    Reset Favourite Players (
                                    {
                                      props.player_information
                                        .gameInformationReducer.slate_lfd_count
                                        .favourite
                                    }
                                    )
                                  </div>
                                </span>
                                <Divider />
                              </>
                            ) : null}
                            {props.player_information.gameInformationReducer
                              .slate_lfd_count.excluded > 0 ? (
                              <>
                                <span
                                  className="dropdown-item "
                                  onClick={async () =>
                                    await resetSlateLFD(false, false, true)
                                  }
                                >
                                  <div className="text-danger">
                                    Reset Excluded Players (
                                    {
                                      props.player_information
                                        .gameInformationReducer.slate_lfd_count
                                        .excluded
                                    }
                                    )
                                  </div>
                                </span>
                                <Divider />
                              </>
                            ) : null}
                          </div>
                        </Drawer>
                      </React.Fragment>
                    ))}
                  </ThemeProvider>
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle text-white"
                      href="#"
                      id="navbarDropdown2"
                      role="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <b>{PlRes}</b>
                    </a>

                    <div
                      className="dropdown-menu bg-dark dropdown-menu-lg-right dropdown-menu-md-right gen-by"
                      aria-labelledby="navbarDropdown3"
                    >
                      {player_responsibility_mapping.map(
                        (responsibility_obj, index) => (
                          <span
                            className="dropdown-item plres"
                            onClick={() =>
                              changePlRes(responsibility_obj.display_name)
                            }
                            style={{ cursor: "pointer" }}
                            key={index}
                          >
                            <div className="text-white">
                              {responsibility_obj.display_name}
                            </div>
                            <div className="text-muted">
                              <small>{responsibility_obj.menu_name}</small>
                            </div>
                          </span>
                        )
                      )}
                    </div>
                  </li>

                  <li
                    className="nav-item lineups"
                    data-toggle="collapse"
                    data-target="#navbar2"
                    aria-controls="navbar2 "
                    aria-expanded="false"
                    onClick={openLineupModal}
                    id="lineup-li"
                  >
                    <a className="nav-link disabled text-white font-weight-bold">
                      Lineups
                    </a>
                  </li>
                </ul>
              </div>
              <div
                className="modal fade"
                id="staticBackdropLineUp"
                data-backdrop="staticLineUp"
                tabindex="-1"
                role="dialog"
                aria-labelledby="staticBackdropLabelLineUp"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header d-flex bg-dark text-center text-white lead">
                      Lineup Generation
                      <button
                        type="button"
                        className="close text-white"
                        data-dismiss="modal"
                        aria-label="Close"
                        onClick={closeLineupModal}
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="bg-black p-5">
                      <center>
                        <p className="text-white lead">Coming Soon</p>
                      </center>
                    </div>

                    <div class="modal-footer bg-black">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal"
                        onClick={closeLineupModal}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </nav>
          </LoadingOverlay>
        </header>
      </>
    );
  },
  (prevProps, nextProps) => {
    console.log("Header Memo Props");
    console.log(prevProps, nextProps);
    if (
      prevProps.player_information.gameInformationReducer.match_datetime !==
      nextProps.player_information.gameInformationReducer.match_datetime
    ) {
      return false;
    } else if (
      prevProps.player_information.gameInformationReducer.game_teams !==
      nextProps.player_information.gameInformationReducer.game_teams
    ) {
      return false;
    } else if (
      prevProps.player_information.gameInformationReducer.slate_lfd_count !==
      nextProps.player_information.gameInformationReducer.slate_lfd_count
    ) {
      return false;
    } else if (
      prevProps.player_information.gameInformationReducer
        .player_position_filter !==
      nextProps.player_information.gameInformationReducer.player_position_filter
    ) {
      return false;
    } else if (
      prevProps.player_information.gameInformationReducer.pl_res !==
      nextProps.player_information.gameInformationReducer.pl_res
    ) {
      return false;
    } else if (
      prevProps.player_information.gameInformationReducer.filtered_team !==
      nextProps.player_information.gameInformationReducer.filtered_team
    ) {
      return false;
    } else if (
      prevProps.player_information.gameInformationReducer.player_counts !==
      nextProps.player_information.gameInformationReducer.player_counts
    ) {
      return false;
    } else if (
      prevProps.player_information.gameInformationReducer
        .player_searched_name !==
      nextProps.player_information.gameInformationReducer.player_searched_name
    ) {
      return false;
    } else if (
      prevProps.player_information.gameInformationReducer.player_sort_type !==
      nextProps.player_information.gameInformationReducer.player_sort_type
    ) {
      return false;
    } else if (
      prevProps.player_information.gameInformationReducer.player_sort_order !==
      nextProps.player_information.gameInformationReducer.player_sort_order
    ) {
      return false;
    }
    // PlayerStatInformationReducer Check
    else if (
      prevProps.player_information.playerStatInformationReducer.ps_m_played !==
      nextProps.player_information.playerStatInformationReducer.ps_m_played
    ) {
      return false;
    } else if (
      prevProps.player_information.playerStatInformationReducer.ps_cap_count !==
      nextProps.player_information.playerStatInformationReducer.ps_cap_count
    ) {
      return false;
    } else if (
      prevProps.player_information.playerStatInformationReducer
        .ps_vcap_count !==
      nextProps.player_information.playerStatInformationReducer.ps_vcap_count
    ) {
      return false;
    } else if (
      prevProps.player_information.playerStatInformationReducer.ps_dt_count !==
      nextProps.player_information.playerStatInformationReducer.ps_dt_count
    ) {
      return false;
    } else if (
      prevProps.player_information.playerStatInformationReducer.ps_credits !==
      nextProps.player_information.playerStatInformationReducer.ps_credits
    ) {
      return false;
    } else if (
      prevProps.player_information.playerStatInformationReducer.ps_totalFP !==
      nextProps.player_information.playerStatInformationReducer.ps_totalFP
    ) {
      return false;
    } else if (
      prevProps.player_information.playerStatInformationReducer.ps_totalFPL4 !==
      nextProps.player_information.playerStatInformationReducer.ps_totalFPL4
    ) {
      return false;
    } else if (
      prevProps.player_information.playerStatInformationReducer.ps_sellBy !==
      nextProps.player_information.playerStatInformationReducer.ps_sellBy
    ) {
      return false;
    } else if (
      prevProps.player_information.playerStatInformationReducer.ps_ppgYear !==
      nextProps.player_information.playerStatInformationReducer.ps_ppgYear
    ) {
      return false;
    } else if (
      prevProps.player_information.playerStatInformationReducer.ps_ppgL4 !==
      nextProps.player_information.playerStatInformationReducer.ps_ppgL4
    ) {
      return false;
    } else if (
      prevProps.player_information.playerStatInformationReducer.ps_projVal !==
      nextProps.player_information.playerStatInformationReducer.ps_projVal
    ) {
      return false;
    } else if (
      prevProps.player_information.playerStatInformationReducer.ps_valYear !==
      nextProps.player_information.playerStatInformationReducer.ps_valYear
    ) {
      return false;
    } else if (
      prevProps.player_information.playerStatInformationReducer.ps_valL4 !==
      nextProps.player_information.playerStatInformationReducer.ps_valL4
    ) {
      return false;
    } else if (
      prevProps.player_information.playerStatInformationReducer.ps_ceil !==
      nextProps.player_information.playerStatInformationReducer.ps_ceil
    ) {
      return false;
    } else if (
      prevProps.player_information.playerStatInformationReducer.ps_floor !==
      nextProps.player_information.playerStatInformationReducer.ps_floor
    ) {
      return false;
    } else if (
      prevProps.player_information.playerStatInformationReducer.ps_cap !==
      nextProps.player_information.playerStatInformationReducer.ps_cap
    ) {
      return false;
    } else if (
      prevProps.player_information.playerStatInformationReducer.ps_vcap !==
      nextProps.player_information.playerStatInformationReducer.ps_vcap
    ) {
      return false;
    } else if (
      prevProps.player_information.playerStatInformationReducer.ps_proj_fp !==
      nextProps.player_information.playerStatInformationReducer.ps_proj_fp
    ) {
      return false;
    } else if (
      prevProps.player_information.playerStatInformationReducer
        .player_responsibility !==
      nextProps.player_information.playerStatInformationReducer
        .player_responsibility
    ) {
      return false;
    } else if (
      prevProps.player_information.playerStatInformationReducer.ps_gpp !==
      nextProps.player_information.playerStatInformationReducer.ps_gpp
    ) {
      return false;
    } else if (
      prevProps.player_information.playerStatInformationReducer.ps_h2h !==
      nextProps.player_information.playerStatInformationReducer.ps_h2h
    ) {
      return false;
    }
    else if (nextProps.player_information.gameInformationReducer.sports != null && findSportByLeague(
      nextProps.player_information.gameInformationReducer.sports,
      nextProps.remoteConfig, "header memo"
    ).toLowerCase() == "cricket"

    ) {
      if (
        prevProps.player_information.playerStatInformationReducer.ps_dta !==
        nextProps.player_information.playerStatInformationReducer.ps_dta
      ) {
        return false;
      }
      else if (
        prevProps.player_information.playerStatInformationReducer.ps_tfpr_count !==
        nextProps.player_information.playerStatInformationReducer.ps_tfpr_count
      ) {
        return false;
      }
      else if (
        prevProps.player_information.playerStatInformationReducer.ps_tfprL4_count !==
        nextProps.player_information.playerStatInformationReducer.ps_tfprL4_count
      ) {
        return false;
      }
      else if (
        prevProps.player_information.playerStatInformationReducer.ps_afpr_count !==
        nextProps.player_information.playerStatInformationReducer.ps_afpr_count
      ) {
        return false;
      }
      else if (
        prevProps.player_information.playerStatInformationReducer.ps_afprL4_count !==
        nextProps.player_information.playerStatInformationReducer.ps_afprL4_count
      ) {
        return false;
      }
      else if (
        prevProps.player_information.playerStatInformationReducer.ps_tfp !==
        nextProps.player_information.playerStatInformationReducer.ps_tfp
      ) {
        return false;
      }
      else if (
        prevProps.player_information.playerStatInformationReducer.ps_tfpL4 !==
        nextProps.player_information.playerStatInformationReducer.ps_tfpL4
      ) {
        return false;
      }
      else if (
        prevProps.player_information.playerStatInformationReducer.ps_afp !==
        nextProps.player_information.playerStatInformationReducer.ps_afp
      ) {
        return false;
      }
      else if (
        prevProps.player_information.playerStatInformationReducer.ps_afpL4 !==
        nextProps.player_information.playerStatInformationReducer.ps_afpL4
      ) {
        return false;
      }
    }
    else {
      return true;
    }
  }
);

const mapStateToProps = (state) => {
  return {
    player_information: state,
    state_slate_lfd_count: state.gameInformationReducer.slate_lfd_count,
    state_slate_locked_count:
      state.gameInformationReducer.slate_lfd_count.locked,
    state_slate_favourite_count:
      state.gameInformationReducer.slate_lfd_count.favourite,
    state_slate_excluded_count:
      state.gameInformationReducer.slate_lfd_count.excluded,
    league: state.gameInformationReducer.sports,
    remoteConfig: state.rcReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    player_sort_value: (value) => dispatch(setSortType(value)),
    player_position_filter: (value) => dispatch(setPositionFilter(value)),
    pl_res: (value) => dispatch(setPlRes(value)),
    updateStatVisibility: (key, value) => dispatch(setPlayerStat(key, value)),
    updatePlayerSearchTerm: (value) => dispatch(setPlayerSearchedName(value)),
    update_player_counts: (value) => dispatch(setPlayerCounts(value)),
    update_filtered_team: (value) => dispatch(setTeamFilter(value)),
    update_player_status: (value) => dispatch(setPlayerStatus(value)),
    update_lfd_count: (value) => dispatch(setPlayerLFDCount(value)),
    update_display_players: (value) => dispatch(setDisplayPlayers(value)),
    update_is_reset_clicked: (value) => dispatch(setIsResetClicked(value)),
    update_player_lfd_flag: (value) => dispatch(updateDisplayPlayers(value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
